import React from "react";

const CustomerRadio = ({ name, value, selectedValue, onChange }) => {
  return (
    <input
      type="radio"
      name={name}
      value={value}
      checked={String(selectedValue) === String(value)}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default CustomerRadio;
